var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStoringBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82.585,
    height: 82.585,
    viewBox: "0 0 82.585 82.585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7768",
    "data-name": "Trazado 7768",
    d: "M41.292,28.031A13.261,13.261,0,1,0,54.553,41.292,13.276,13.276,0,0,0,41.292,28.031M41.292,0A41.292,41.292,0,1,1,0,41.292,41.292,41.292,0,0,1,41.292,0Z",
    fill: "#fff",
    opacity: 0.997
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoringBg1);
export default __webpack_public_path__ + "static/media/storingBg1.06302a160375bc49fcb5316a1f820c95.svg";
export { ForwardRef as ReactComponent };